import { AttachmentModel } from '../models/attachment.model';
import { computed, Ref } from 'vue';
import { ScanningStatusEnum } from '../enums/scanningStatus.enum';
import { mediaTypes } from '../enums/mediaTypes';
import i18n from '../locales/i18n';

export const useAttachmentScan = (attachment: Ref<AttachmentModel>, textLength: 'long' | 'short' = 'long') => {
  const scanningStatus = computed(
    () => attachment.value.file?.scanningStatus || attachment.value.media?.file.scanningStatus || null
  );

  const scanningText = computed(() => {
    const mediaType = attachment.value.media?.mediaType || null;

    if (scanningStatus.value === ScanningStatusEnum.PROCESSING) {
      if (textLength === 'short') {
        return getProcessingTextShort(mediaType);
      } else {
        return getProcessingTextLong(mediaType);
      }
    }

    if (scanningStatus.value === ScanningStatusEnum.BLOCKED) {
      if (textLength === 'short') {
        return i18n.t('file.file_scan_blocked_short');
      } else {
        return i18n.t('file.file_scan_blocked_document');
      }
    }
    return null;
  });

  const isDisabled = computed(
    () => scanningStatus.value === ScanningStatusEnum.PROCESSING || scanningStatus.value === ScanningStatusEnum.BLOCKED
  );

  const getProcessingTextShort = (mediaType: mediaTypes) => {
    switch (mediaType) {
      case mediaTypes.IMAGE:
        return i18n.t('file.file_scan_processing_image_short');
      case mediaTypes.VIDEO:
        return i18n.t('file.file_scan_processing_video_short');
      case mediaTypes.SOUND:
        return i18n.t('file.file_scan_processing_audio_short');
      default:
        return i18n.t('file.file_scan_processing_document_short');
    }
  };

  const getProcessingTextLong = (mediaType: mediaTypes) => {
    switch (mediaType) {
      case mediaTypes.IMAGE:
        return i18n.t('file.file_scan_processing_image');
      case mediaTypes.VIDEO:
        return i18n.t('file.file_scan_processing_video');
      case mediaTypes.SOUND:
        return i18n.t('file.file_scan_processing_audio');
      default:
        return i18n.t('file.file_scan_processing_document');
    }
  };

  return {
    scanningText,
    scanningStatus,
    isDisabled,
  };
};
